import api from '@/utils/axios';

/**
 * 스케줄러 설정 관련 API 서비스
 */
const schedulerService = {
  /**
   * 스케줄러 설정 목록 조회
   * @returns {Promise<Array>} 스케줄러 설정 목록
   */
  async getSchedulerSettings() {
    try {
      const response = await api.get('/api/v1/scheduler-settings');
      return response || [];
    } catch (error) {
      console.error('스케줄러 설정 목록 조회 실패:', error);
      throw error;
    }
  },

  /**
   * 스케줄러 on/off 토글
   * @param {string} type - 스케줄러 타입
   * @param {boolean} isActive - 활성화 여부
   * @returns {Promise<void>}
   */
  async toggleScheduler(type, isActive) {
    try {
      await api.patch('/api/v1/scheduler-settings/toggle', {
        type,
        isActive
      });
    } catch (error) {
      console.error('스케줄러 토글 실패:', error);
      throw error;
    }
  }
};

export default schedulerService;
